
import TouchFullscreen from '../../Components/TouchFullscreen/TouchFullscreen';
import { makeStyles } from 'tss-react/mui';

interface IProps {
  open: boolean;
  close: (event: React.MouseEvent) => void;
  onCancel?: (event: React.MouseEvent) => void;
  onEntered?: () => void;
  navigatePrev?: () => void;
  navigateNext?: () => void;
  currentView?: number;
  totalViews?: number;
  setRef: (element: HTMLDivElement) => void;
  setOptionsRef: (element: HTMLDivElement) => void;
  usesOldAutocomplete?: boolean;
}

const useStyles = makeStyles()({
  refContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  optionsContainer: {
    overflowY: 'auto',
  },
  innerRefContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  innerRefOptionsContainer: {
    flex: 1,
    overflow: 'auto',
  },
});

const TouchFullscreenInput: React.FC<React.PropsWithChildren<IProps>> = ({
  setRef,
  setOptionsRef,
  ...props
}) => {
  const { classes, cx } = useStyles();
  return (
    <TouchFullscreen
      open={props.open}
      close={props.close}
      onCancel={props.onCancel ? props.onCancel : () => {}}
      onEntered={props.onEntered ? props.onEntered : () => {}}
      navigatePrev={props.navigatePrev}
      navigateNext={props.navigateNext}
      currentView={props.currentView !== null ? props.currentView : 1}
      totalViews={props.totalViews}
    >
      <div className={classes.refContainer}>
        <div
          ref={setRef}
          className={cx(classes.innerRefContainer, {
            [classes.innerRefOptionsContainer]: !props.usesOldAutocomplete,
          })}
        ></div>
        <div ref={setOptionsRef} className={classes.optionsContainer}></div>
      </div>
    </TouchFullscreen>
  );
};

export default TouchFullscreenInput;
